import { DATE_FORAT } from '@/constants/ConstantType';
import store from '@/store';
import moment from 'moment';

Array.prototype.toDropdownlist = function () {
  return this.map((m) => ItemSelected({ text: m.name, value: m.id }));
};

Array.prototype.toSelectedByValue = function ({ value, defaultValue }) {
  const itemsSelected = this.find((m) => m.value == value);
  if (!itemsSelected) {
    if (defaultValue) return this.find((m) => m.value == defaultValue);
    else {
      return {};
    }
  } else {
    return itemsSelected;
  }
};
// Extend the Array prototype with a custom sortBy method
Array.prototype.sortBy = function (property, order = 'asc') {
  return this.sort((a, b) => {
    // Handle nested properties (e.g., 'person.age')
    const valueA = property.split('.').reduce((obj, key) => obj[key], a);
    const valueB = property.split('.').reduce((obj, key) => obj[key], b);

    // Compare values
    if (valueA < valueB) {
      return order === 'asc' ? -1 : 1;
    }
    if (valueA > valueB) {
      return order === 'asc' ? 1 : -1;
    }
    return 0; // Values are equal
  });
};

String.prototype.mileageStringFormat = function () {
  const v = this || '';
  const [mileageNumber = 0, unit = 'Km'] = (v || '')?.split(':');
  return mileageNumber ? mileageNumber + ' ' + unit : '';
};

String.prototype.mileageObjectFormat = function () {
  const v = this || '';
  const [mileageNumber = 0, unit = 'Km'] = (v || '')?.split(':');
  return { unit, value: mileageNumber };
};

String.prototype.defaultValueTable = function (defaultValue) {
  return this || defaultValue;
};

String.prototype.toTitleCase = function () {
  const spacedStr = this.replace(/([a-z])([A-Z])/g, '$1 $2');

  // Convert snake_case to space-separated words
  const spacedStrWithUnderscore = spacedStr.replace(/_/g, ' ');

  // Convert to Title Case
  return spacedStrWithUnderscore.replace(/\w\S*/g, (txt) => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export function ItemSelected({ text = null, value = null }) {
  const selectItem = { text: text, value: value };
  if (value) return selectItem;
  else {
    return null;
  }
}

export function isObjectNotEmpty(obj) {
  // the properties of the object
  let isContainTrue = [];
  for (let key in obj) {
    const value = obj[key];

    // If the property is an array, check if it's not empty
    if (value) {
      if (Array.isArray(value) && value) {
        if (value.length) {
          isContainTrue.push(true);
        }
      } else if (typeof value == 'object' && value) {
        if (Object.keys(value)?.length) isContainTrue.push(true);
      } else {
        isContainTrue.push(true);
      }
    }
  }

  const isTrue = isContainTrue?.find((v) => v);
  return isTrue;
}

export function dateFormatLocal(date, format = 'YYY/MM/DD HH:mm:ss [GMT]') {
  const dateForm = moment(date, format);
  const startDate = dateForm.format(DATE_FORAT.LOCAL_DATE); // January 1st, 00:00

  return startDate;
}

export function getStartAndEndOfYear(year) {
  const format = 'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (zzzz)';
  const dateNow = new Date();
  const dateYear = moment(dateNow, format).year(year);
  const startDate = dateYear.startOf('year').format(DATE_FORAT.LOCAL_DATE); // January 1st, 00:00
  const endDate = dateYear.endOf('year').format(DATE_FORAT.LOCAL_DATE); // December 31st, 23:59

  return {
    startDate,
    endDate,
  };
}

function getNestedValue(obj, path, delimiter = '/') {
  const keys = path.split(delimiter);

  return keys.reduce((acc, key) => {
    return acc ? acc[key] : undefined;
  }, obj);
}

function setNestedValue(obj, path, value, delimiter = '/') {
  const keys = path.split(delimiter);

  keys.reduce((acc, key, index) => {
    // If this is the last key, set the value
    if (index === keys.length - 1) {
      acc[key] = value;
    } else {
      // Otherwise, keep iterating down the object, creating new objects if necessary
      if (!acc[key]) {
        acc[key] = {}; // create empty object if it doesn't exist
      }
    }
    return acc[key]; // move down the object
  }, obj);
}

export const CONST_MILLEAGE = {
  MILEAGE: 'MILEAGE',
  KM: 'Km',
  MILE: 'Mile',
};

export const TYPE_CONTROL = {
  SINGLE_SELECT: 'single-select',
  MULTI_SELECT: 'multi-select',
  SINGLE_SELECT_ASYNC: 'single-select-async',
  SINGLE_SELECT_LOOKUP_ASYNC: 'single-select-lookup-async',
  MULTI_SELECT_ASYNC: 'multi-select-async',
  INPUT_TEXT: 'text',
  INPUT_NUMBER: 'number',
  INPUT_DATE: 'datetime',
  INPUT_FILE: 'file',
  TEXTAREA: 'textarea',
  CHECKBOX: 'checkbox',
  BOX_IMG_GROUP: 'img-group',
  INPUT_NUMBER_SYMBOL: 'INPUT_NUMBER_SYMBOL',
  PHONE: 'pnone',
  TAB: 'tab',
  MENU_DROPDOWN: 'MENU_DROPDOWN',
};
export function createPrintIframe(htmlContent) {
  const existingIframe = document.getElementById('print-iframe');
  if (existingIframe) {
    return existingIframe;
  }
  const iframe = document.createElement('iframe');
  iframe.id = 'print-iframe';
  iframe.style.position = 'absolute';
  iframe.style.width = '0px';
  iframe.style.height = '0px';
  iframe.style.border = 'none';
  document.body.appendChild(iframe);

  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(htmlContent);
  doc.close();
  iframe.onload = () => {
    try {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    } catch (error) {
      console.error('Print failed:', error);
    } finally {
    }
  };

  return iframe;
}
export function toTitleCase(str) {
  return str
    .toLowerCase() // Convert entire string to lowercase first
    .split(' ') // Split into words
    .map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1) // Capitalize first letter
    )
    .join(' '); // Rejoin with spaces
}
/**
 * Check for duplicate values in an array of objects based on a specific property
 * @param {Array} array - The array of objects to check
 * @param {string} property - The property name to check for duplicates
 * @param {boolean} [ignoreDeleted=true] - Whether to ignore items marked as deleted
 * @returns {Object} Object containing duplicate information
 */
export function checkDuplicateIds(array, property, ignoreDeleted = true) {
  if (!Array.isArray(array) || !property) {
    return {
      hasDuplicates: false,
      duplicates: [],
      duplicateCounts: {},
    };
  }

  // Filter out deleted items if ignoreDeleted is true
  const itemsToCheck = ignoreDeleted ? array.filter((item) => !item.isDeleted && item?.[property]) : array;

  // Count occurrences of each value
  const counts = _.countBy(itemsToCheck, property);

  // Find items that appear more than once
  const duplicates = Object.entries(counts)
    .filter(([_, count]) => count > 1)
    .map(([value]) => value);

  // Get detailed count of duplicates
  const duplicateCounts = Object.entries(counts)
    .filter(([_, count]) => count > 1)
    .reduce((acc, [value, count]) => {
      acc[value] = count;
      return acc;
    }, {});

  return {
    hasDuplicates: duplicates.length > 0,
    duplicates,
    duplicateCounts,
  };
}

export function findAviabledMenuPermissionAllow({ menus = [], muduleName = '' }) {
  const inventoryMenu = menus.find((menu) => menu?.path === muduleName);
  if (!inventoryMenu) return null;

  const { children = [] } = inventoryMenu;
  const availableMenu = children.find((child) => store.getters['userPermission/hasPermission'](child.permission));

  return availableMenu || null;
}

/**
 * Returns a new array with unique objects based on a property.
 * @param {Array} arr - The array of objects.
 * @param {string|function} key - The property name or a function to get the key.
 * @returns {Array}
 */
export function distinctBy(arr, key) {
  const seen = new Set();
  return arr.filter((item) => {
    const val = typeof key === 'function' ? key(item) : item[key];
    if (seen.has(val)) return false;
    seen.add(val);
    return true;
  });
}
/**
 * Returns a new array with only unique primitive values.
 * @param {Array} arr
 * @returns {Array}
 */
export function distinct(arr) {
  return Array.from(new Set(arr));
}
